module.exports = __webpack_public_path__ + "static/media/20240530090054_IMG_7494.4b68a0c9.JPG";